<template>
  <svg
    v-if="size === 'large'"
    width="217"
    height="40"
    viewBox="0 0 217 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0921 2.02483C20.2992 1.3875 21.2008 1.3875 21.4079 2.02483L25.085 13.3417C25.1776 13.6267 25.4432 13.8197 25.7429 13.8197H37.6421C38.3122 13.8197 38.5909 14.6772 38.0487 15.0711L28.422 22.0653C28.1796 22.2414 28.0781 22.5537 28.1707 22.8387L31.8478 34.1555C32.0549 34.7928 31.3254 35.3228 30.7833 34.9289L21.1566 27.9347C20.9142 27.7586 20.5858 27.7586 20.3434 27.9347L10.7167 34.9289C10.1746 35.3228 9.44512 34.7928 9.6522 34.1555L13.3293 22.8387C13.4219 22.5537 13.3204 22.2414 13.078 22.0653L3.45129 15.0711C2.90915 14.6772 3.18777 13.8197 3.8579 13.8197H15.7571C16.0568 13.8197 16.3224 13.6267 16.415 13.3417L20.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M64.0921 2.02483C64.2992 1.3875 65.2008 1.3875 65.4079 2.02483L69.085 13.3417C69.1776 13.6267 69.4432 13.8197 69.7429 13.8197H81.6421C82.3122 13.8197 82.5909 14.6772 82.0487 15.0711L72.422 22.0653C72.1796 22.2414 72.0781 22.5537 72.1707 22.8387L75.8478 34.1555C76.0549 34.7928 75.3254 35.3228 74.7833 34.9289L65.1566 27.9347C64.9142 27.7586 64.5858 27.7586 64.3434 27.9347L54.7167 34.9289C54.1746 35.3228 53.4451 34.7928 53.6522 34.1555L57.3293 22.8387C57.4219 22.5537 57.3204 22.2414 57.078 22.0653L47.4513 15.0711C46.9091 14.6772 47.1878 13.8197 47.8579 13.8197H59.7571C60.0568 13.8197 60.3224 13.6267 60.415 13.3417L64.0921 2.02483Z"
      :fill="fill"
    />
    <path
      d="M108.33 2.10254C108.462 1.69554 109.038 1.69554 109.17 2.10254L112.848 13.4189C112.974 13.8069 113.335 14.0693 113.743 14.0693H125.643C126.07 14.0697 126.247 14.6177 125.901 14.8691L116.275 21.8633C115.945 22.1031 115.807 22.528 115.933 22.916L119.61 34.2324C119.743 34.6393 119.277 34.9778 118.931 34.7266L109.304 27.7324C108.974 27.4926 108.526 27.4926 108.196 27.7324L98.5693 34.7266C98.2231 34.9778 97.7574 34.6393 97.8896 34.2324L101.567 22.916C101.693 22.528 101.555 22.1031 101.225 21.8633L91.5986 14.8691C91.2525 14.6177 91.4298 14.0697 91.8574 14.0693H103.757C104.165 14.0693 104.526 13.8069 104.652 13.4189L108.33 2.10254Z"
      :stroke="fill"
      stroke-width="0.5"
    />
    <mask
      id="mask0_11235_125727"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="91"
      y="1"
      width="36"
      height="35"
    >
      <path
        d="M108.092 2.02483C108.299 1.3875 109.201 1.3875 109.408 2.02483L113.085 13.3417C113.178 13.6267 113.443 13.8197 113.743 13.8197H125.642C126.312 13.8197 126.591 14.6772 126.049 15.0711L116.422 22.0653C116.18 22.2414 116.078 22.5537 116.171 22.8387L119.848 34.1555C120.055 34.7928 119.325 35.3228 118.783 34.9289L109.157 27.9347C108.914 27.7586 108.586 27.7586 108.343 27.9347L98.7167 34.9289C98.1746 35.3228 97.4451 34.7928 97.6522 34.1555L101.329 22.8387C101.422 22.5537 101.32 22.2414 101.078 22.0653L91.4513 15.0711C90.9091 14.6772 91.1878 13.8197 91.8579 13.8197H103.757C104.057 13.8197 104.322 13.6267 104.415 13.3417L108.092 2.02483Z"
        :fill="fill"
      />
    </mask>
    <g mask="url(#mask0_11235_125727)">
      <rect
        x="84.7061"
        y="-3.21289"
        width="24.093"
        height="43.3674"
        :fill="fill"
      />
    </g>
    <path
      d="M152.33 2.10254C152.462 1.69554 153.038 1.69554 153.17 2.10254L156.848 13.4189C156.974 13.8069 157.335 14.0693 157.743 14.0693H169.643C170.07 14.0697 170.247 14.6177 169.901 14.8691L160.275 21.8633C159.945 22.1031 159.807 22.528 159.933 22.916L163.61 34.2324C163.743 34.6393 163.277 34.9778 162.931 34.7266L153.304 27.7324C152.974 27.4926 152.526 27.4926 152.196 27.7324L142.569 34.7266C142.223 34.9778 141.757 34.6393 141.89 34.2324L145.567 22.916C145.693 22.528 145.555 22.1031 145.225 21.8633L135.599 14.8691C135.253 14.6177 135.43 14.0697 135.857 14.0693H147.757C148.165 14.0693 148.526 13.8069 148.652 13.4189L152.33 2.10254Z"
      :stroke="fill"
      stroke-width="0.5"
    />
    <path
      d="M196.33 2.10254C196.462 1.69554 197.038 1.69554 197.17 2.10254L200.848 13.4189C200.974 13.8069 201.335 14.0693 201.743 14.0693H213.643C214.07 14.0697 214.247 14.6177 213.901 14.8691L204.275 21.8633C203.945 22.1031 203.807 22.528 203.933 22.916L207.61 34.2324C207.743 34.6393 207.277 34.9778 206.931 34.7266L197.304 27.7324C196.974 27.4926 196.526 27.4926 196.196 27.7324L186.569 34.7266C186.223 34.9778 185.757 34.6393 185.89 34.2324L189.567 22.916C189.693 22.528 189.555 22.1031 189.225 21.8633L179.599 14.8691C179.253 14.6177 179.43 14.0697 179.857 14.0693H191.757C192.165 14.0693 192.526 13.8069 192.652 13.4189L196.33 2.10254Z"
      :stroke="fill"
      stroke-width="0.5"
    />
  </svg>

  <svg
    v-else-if="size === 'base'"
    width="141"
    height="25"
    viewBox="0 0 141 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8421 2.02483C12.0492 1.3875 12.9508 1.3875 13.1579 2.02483L15.1511 8.15929C15.2437 8.44431 15.5093 8.63729 15.809 8.63729H22.2592C22.9293 8.63729 23.2079 9.49481 22.6658 9.8887L17.4475 13.68C17.205 13.8562 17.1036 14.1684 17.1962 14.4534L19.1894 20.5879C19.3965 21.2252 18.667 21.7552 18.1249 21.3613L12.9066 17.57C12.6642 17.3938 12.3358 17.3938 12.0934 17.57L6.87511 21.3613C6.33296 21.7552 5.60351 21.2252 5.81059 20.5879L7.8038 14.4534C7.89641 14.1684 7.79495 13.8562 7.5525 13.68L2.33421 9.8887C1.79207 9.49481 2.0707 8.63729 2.74082 8.63729H9.19098C9.49067 8.63729 9.75628 8.44431 9.84889 8.15929L11.8421 2.02483Z"
      :fill="fill"
    />
    <path
      d="M40.8421 2.02483C41.0492 1.3875 41.9508 1.3875 42.1579 2.02483L44.1511 8.15929C44.2437 8.44431 44.5093 8.63729 44.809 8.63729H51.2592C51.9293 8.63729 52.2079 9.49481 51.6658 9.8887L46.4475 13.68C46.205 13.8562 46.1036 14.1684 46.1962 14.4534L48.1894 20.5879C48.3965 21.2252 47.667 21.7552 47.1249 21.3613L41.9066 17.57C41.6642 17.3938 41.3358 17.3938 41.0934 17.57L35.8751 21.3613C35.333 21.7552 34.6035 21.2252 34.8106 20.5879L36.8038 14.4534C36.8964 14.1684 36.795 13.8562 36.5525 13.68L31.3342 9.8887C30.7921 9.49481 31.0707 8.63729 31.7408 8.63729H38.191C38.4907 8.63729 38.7563 8.44431 38.8489 8.15929L40.8421 2.02483Z"
      :fill="fill"
    />
    <path
      d="M69.9521 2.06055C70.1247 1.52949 70.8753 1.52949 71.0479 2.06055L73.041 8.19531C73.1491 8.52758 73.4592 8.75275 73.8086 8.75293H80.2588C80.8172 8.75293 81.0494 9.46766 80.5977 9.7959L75.3799 13.5869C75.097 13.7924 74.9789 14.1567 75.0869 14.4893L77.0801 20.623C77.2526 21.1542 76.6442 21.5958 76.1924 21.2676L70.9746 17.4766C70.6917 17.2711 70.3083 17.2711 70.0254 17.4766L64.8076 21.2676C64.3558 21.5958 63.7474 21.1542 63.9199 20.623L65.9131 14.4893C66.0211 14.1567 65.903 13.7924 65.6201 13.5869L60.4023 9.7959C59.9506 9.46766 60.1828 8.75293 60.7412 8.75293H67.1914C67.5408 8.75275 67.8509 8.52758 67.959 8.19531L69.9521 2.06055Z"
      :stroke="fill"
      stroke-width="0.230588"
    />
    <mask
      id="mask0_11235_125617"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="60"
      y="1"
      width="21"
      height="21"
    >
      <path
        d="M69.8421 2.02483C70.0492 1.3875 70.9508 1.3875 71.1579 2.02483L73.1511 8.15929C73.2437 8.44431 73.5093 8.63729 73.809 8.63729H80.2592C80.9293 8.63729 81.2079 9.49481 80.6658 9.8887L75.4475 13.68C75.205 13.8562 75.1036 14.1684 75.1962 14.4534L77.1894 20.5879C77.3965 21.2252 76.667 21.7552 76.1249 21.3613L70.9066 17.57C70.6642 17.3938 70.3358 17.3938 70.0934 17.57L64.8751 21.3613C64.333 21.7552 63.6035 21.2252 63.8106 20.5879L65.8038 14.4534C65.8964 14.1684 65.795 13.8562 65.5525 13.68L60.3342 9.8887C59.7921 9.49481 60.0707 8.63729 60.7408 8.63729H67.191C67.4907 8.63729 67.7563 8.44431 67.8489 8.15929L69.8421 2.02483Z"
        :fill="fill"
      />
    </mask>
    <g mask="url(#mask0_11235_125617)">
      <rect
        x="55.4727"
        y="-2.00781"
        width="15.0581"
        height="27.1046"
        :fill="fill"
      />
    </g>
    <path
      d="M98.9521 2.06055C99.1247 1.52949 99.8753 1.52949 100.048 2.06055L102.041 8.19531C102.149 8.52758 102.459 8.75275 102.809 8.75293H109.259C109.817 8.75293 110.049 9.46766 109.598 9.7959L104.38 13.5869C104.097 13.7924 103.979 14.1567 104.087 14.4893L106.08 20.623C106.253 21.1542 105.644 21.5958 105.192 21.2676L99.9746 17.4766C99.6917 17.2711 99.3083 17.2711 99.0254 17.4766L93.8076 21.2676C93.3558 21.5958 92.7474 21.1542 92.9199 20.623L94.9131 14.4893C95.0211 14.1567 94.903 13.7924 94.6201 13.5869L89.4023 9.7959C88.9506 9.46766 89.1828 8.75293 89.7412 8.75293H96.1914C96.5408 8.75275 96.8509 8.52758 96.959 8.19531L98.9521 2.06055Z"
      :stroke="fill"
      stroke-width="0.230588"
    />
    <path
      d="M127.952 2.06055C128.125 1.52949 128.875 1.52949 129.048 2.06055L131.041 8.19531C131.149 8.52758 131.459 8.75275 131.809 8.75293H138.259C138.817 8.75293 139.049 9.46766 138.598 9.7959L133.38 13.5869C133.097 13.7924 132.979 14.1567 133.087 14.4893L135.08 20.623C135.253 21.1542 134.644 21.5958 134.192 21.2676L128.975 17.4766C128.692 17.2711 128.308 17.2711 128.025 17.4766L122.808 21.2676C122.356 21.5958 121.747 21.1542 121.92 20.623L123.913 14.4893C124.021 14.1567 123.903 13.7924 123.62 13.5869L118.402 9.7959C117.951 9.46766 118.183 8.75293 118.741 8.75293H125.191C125.541 8.75275 125.851 8.52758 125.959 8.19531L127.952 2.06055Z"
      :stroke="fill"
      stroke-width="0.230588"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsBaseStarsTwoAndHalfStar'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  },
  size: {
    type: String,
    default: 'base',
    validator: value => ['base', 'large'].includes(value)
  }
})
</script>
